module.exports = __webpack_public_path__ + "static/media/SDGIcons_16.1552937e.png";